// Marks that the last login on this browser was a company login, so an expired
// session is sent back to this app's /login instead of the student/teacher auth portal.
// Survives cookie expiry; cleared by signOut (localStorage.clear) or a non-company session.
const COMPANY_LOGIN_KEY = "isCompanyLogin";

export const setCompanyLogin = () => {
    try {
        localStorage.setItem(COMPANY_LOGIN_KEY, "true");
    } catch { /* storage unavailable */ }
};

export const clearCompanyLogin = () => {
    try {
        localStorage.removeItem(COMPANY_LOGIN_KEY);
    } catch { /* storage unavailable */ }
};

export const isCompanyLogin = () => {
    try {
        return localStorage.getItem(COMPANY_LOGIN_KEY) === "true";
    } catch {
        return false;
    }
};
